import Sidebar from '../../components/sidebar/Sidebar'
import Navbar from '../../components/navbar/Navbar'
import './home.scss'
import Widget from '../../components/widget/Widget'
import Featured from '../../components/featured/Featured'
import Chart from '../../components/chart/Chart'
import SalesTable from '../../components/table/SalesTable'
// import React, { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../../firebase'
import { useContext, useEffect, useState } from 'react'

const Home = ({user}) => {


    const { currentUser } = useContext(AuthContext)
  
    const userId = currentUser.uid;

    const [adminRole, setAdminRole] = useState("")

    const getAdminRole = async() => {
      
            const docRef = doc(db, "admins", userId);
      
            const docSnap = await getDoc(docRef);
      
            
            if (docSnap.exists()) {
      
              setAdminRole(docSnap.data().role)

            } else {

              console.log("No such document!");
            }
    }

    useEffect(()=>  {

      getAdminRole()

    }, [])

  return (
    <div className='home'>
        <Sidebar />
        <div className="homeContainer">
          <Navbar/>

          {

               adminRole === "adminAccess"

                ?

                <div className="widgets">
                <Widget type="users"/>
                <Widget type="subscribers"/>
                <Widget type="outlets"/>
                <Widget type="adverts"/>
        
                
                </div>

                :

                adminRole === "subadminAccess"

                ?

                <div className="widgets">
                <Widget type="users"/>
                <Widget type="subscribers"/>
                <Widget type="outlets"/>
                <Widget type="adverts"/>
        
                
                </div>


                :

                ""

          }

     
          {/* <div className="charts">
            <Featured/>
            <Chart 
              aspect = {2 / 1}
              title = "Last 6 Months Revenue "
            />
          </div> */}
          <div className='listContainer'>
              <div className='listTitle'>Lastest Transaction</div>
              <SalesTable/>
          </div>
        </div>
    </div>
  )
}

export default Home